import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

type LoadModalState = {
  isLoadModalOpen: boolean;
  selectedDistributorId: number | null;
};

type LoadModalActions = {
  openLoadModal: () => void;
  closeLoadModal: () => void;
  setSelectedDistributorId: (distributorId: number) => void;
  resetSelectedDistributorId: () => void;
};

type LoadModalStore = LoadModalState & LoadModalActions;

const initialState: LoadModalState = {
  isLoadModalOpen: false,
  selectedDistributorId: null,
};

export const useLoadModalStore = create<LoadModalStore>()(
  devtools(
    immer(set => ({
      ...initialState,

      openLoadModal: () => {
        set(state => {
          state.isLoadModalOpen = true;
        });
      },

      closeLoadModal: () => {
        set(state => {
          state.isLoadModalOpen = false;
          state.selectedDistributorId = null;
        });
      },

      setSelectedDistributorId: (distributorId: number) => {
        set(state => {
          state.selectedDistributorId = distributorId;
        });
      },

      resetSelectedDistributorId: () => {
        set(state => {
          state.selectedDistributorId = null;
        });
      },
    })),
    { name: 'load-modal-store' },
  ),
);

// Selectors
export const selectIsLoadModalOpen = (state: LoadModalStore) => state.isLoadModalOpen;
export const selectSelectedDistributorId = (state: LoadModalStore) => state.selectedDistributorId;

// Actions hook
export const useLoadModalActions = () => {
  const openLoadModal = useLoadModalStore(state => state.openLoadModal);
  const closeLoadModal = useLoadModalStore(state => state.closeLoadModal);
  const setSelectedDistributorId = useLoadModalStore(state => state.setSelectedDistributorId);
  const resetSelectedDistributorId = useLoadModalStore(state => state.resetSelectedDistributorId);

  return {
    openLoadModal,
    closeLoadModal,
    setSelectedDistributorId,
    resetSelectedDistributorId,
  };
};
